import { Physics, Spine } from '@esotericsoftware/spine-pixi-v8';
import { BitmapText, Texture } from 'pixi.js';
import { GameConstants } from '../gameClientEvents/GameConstants';

// Define the mapping configuration
const symbolConfig: Record<number, { blurSymName: string; staticSymName: string; skeleton: string; atlas: string }> = {
    0: {
        blurSymName: "wildSilverBlur",
        staticSymName: "wildSilverStatic",
        skeleton: "wildSilverSkel",
        atlas: "wildSilverAtlas"
    },
    1: {
        blurSymName: "lv6Blur",
        staticSymName: "lv6Static",
        skeleton: "lv6Skel",
        atlas: "lv6Atlas"
    },
    2: {
        blurSymName: "lv5Blur",
        staticSymName: "lv5Static",
        skeleton: "lv5Skel",
        atlas: "lv5Atlas"
    },
    3: {
        blurSymName: "lv4Blur",
        staticSymName: "lv4Static",
        skeleton: "lv4Skel",
        atlas: "lv4Atlas"
    },
    4: {
        blurSymName: "lv3Blur",
        staticSymName: "lv3Static",
        skeleton: "lv3Skel",
        atlas: "lv3Atlas"
    },
    5: {
        blurSymName: "lv2Blur",
        staticSymName: "lv2Static",
        skeleton: "lv2Skel",
        atlas: "lv2Atlas"
    },
    6: {
        blurSymName: "lv1Blur",
        staticSymName: "lv1Static",
        skeleton: "lv1Skel",
        atlas: "lv1Atlas"
    },
    7: {
        blurSymName: "hv5Blur",
        staticSymName: "hv5Static",
        skeleton: "hv5Skel",
        atlas: "hv5Atlas"
    },
    8: {
        blurSymName: "hv4Blur",
        staticSymName: "hv4Static",
        skeleton: "hv4Skel",
        atlas: "hv4Atlas"
    },
    9: {
        blurSymName: "hv3Blur",
        staticSymName: "hv3Static",
        skeleton: "hv3Skel",
        atlas: "hv3Atlas"
    },
    10: {
        blurSymName: "hv2Blur",
        staticSymName: "hv2Static",
        skeleton: "hv2Skel",
        atlas: "hv2Atlas"
    },
    11: {
        blurSymName: "hv1Blur",
        staticSymName: "hv1Static",
        skeleton: "hv1Skel",
        atlas: "hv1Atlas"
    },
    12: {
        blurSymName: "scatterBlur",
        staticSymName: "scatterStatic",
        skeleton: "scatterSkel",
        atlas: "scatterAtlas"
    },
    13: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    14: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    15: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    16: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    17: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    18: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    19: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    20: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    21: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    22: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    23: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    24: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    25: {
        blurSymName: "specialSymbolBlur",
        staticSymName: "specialSymbolStatic",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    26: {
        blurSymName: "miniBlur",
        staticSymName: "miniStatic",
        skeleton: "miniSkel",
        atlas: "miniAtlas"
    },
    27: {
        blurSymName: "minorBlur",
        staticSymName: "minorStatic",
        skeleton: "minorSkel",
        atlas: "minorAtlas"
    },
    28: {
        blurSymName: "majorBlur",
        staticSymName: "majorStatic",
        skeleton: "majorSkel",
        atlas: "majorAtlas"
    },
    29: {
        blurSymName: "grandBlur",
        staticSymName: "grandStatic",
        skeleton: "grandSkel",
        atlas: "grandAtlas"
    },
    40: { // blank
        blurSymName: "blankSymbol",
        staticSymName: "blankSymbol",
        skeleton: "specialSymbolSkel",
        atlas: "specialSymbolAtlas"
    },
    30: {
        blurSymName: "wildGoldBlur",
        staticSymName: "wildGoldStatic",
        skeleton: "wildGoldSkel",
        atlas: "wildGoldAtlas"
    },
    31: { //blocked
        blurSymName: "lv6Blur",
        staticSymName: "lv6Static",
        skeleton: "lv6Skel",
        atlas: "lv6Atlas"
    },
    // Add more mappings as needed
};

export const SymbolValues = [{ id: 13, value: 1 }, { id: 14, value: 2 }, { id: 15, value: 3 }, { id: 16, value: 4 }, { id: 17, value: 5 }, { id: 18, value: 6 }, { id: 19, value: 7 }, { id: 20, value: 8 }, { id: 21, value: 9 }, { id: 22, value: 10 }, { id: 23, value: 20 }, { id: 24, value: 50 }, { id: 25, value: 100 }, { id: 26, value: 10 }, { id: 27, value: 100 }, { id: 28, value: 500 }, { id: 29, value: 2500 }];

export const valMap = SymbolValues.reduce<Record<number, any>>((acc, curr) => {
    acc[curr.id] = curr.value;
    return acc;
}, {});

export function isOversizeSymbol(symbolIndex: number): boolean {

    let isSymbolOversize = false;
    if (symbolIndex == 0)// || symbolIndex == 9)
    {
        isSymbolOversize = false;
    }
    return isSymbolOversize;

}

export function isLandingAnimationExist(symbolIndex: number): boolean {
    let isLandingExist = true;
    if (symbolIndex == 0 || symbolIndex == 9) {
        isLandingExist = true;
    }
    return isLandingExist;
}


export function getSymbol(symbolIndex: number, isFullRes?: boolean): Texture {

    let staticSymName: string = '';

    const symbol = (symbolIndex === GameConstants.BLOCKED_SYMBOL_ID) ? symbolConfig[Math.floor(Math.random() * 6) + 1] : symbolConfig[symbolIndex];

    if (symbol) {
        if (isFullRes && isFullRes == true) {
            staticSymName = symbol.staticSymName;
        }
        else {
            staticSymName = symbol.blurSymName;
        }
    }

    const staticSymbol: Texture = Texture.from(staticSymName);
    return staticSymbol;

}


export function getSpineSymbol(symbolIndex: number): Spine {
    const symbol = symbolConfig[symbolIndex];
    //console.log("symbol id " + symbolIndex);
    let skeletonVal: string = '';
    let atlasVal: string = '';

    if (symbol) {

        skeletonVal = symbol.skeleton;
        atlasVal = symbol.atlas;

    }


    const spineSymbol: Spine = Spine.from({
        skeleton: skeletonVal,
        atlas: atlasVal,
    });

    if (symbolIndex >= GameConstants.GOLD_COIN_START_SYMBOL_ID && symbolIndex <= GameConstants.GOLD_COIN_END_SYMBOL_ID) {
        const slot = spineSymbol.skeleton.findSlot("multiplier");
        if (slot && !spineSymbol.getSlotObject("multiplier")) {
            let coinVal = SymbolValues.find(s => s.id === symbolIndex)?.value || 0;

            const coinValText = new BitmapText({
                text: `${coinVal}x`,
                style: {
                    fontFamily: "coin_font",
                    fontSize: 100,
                }
            });
            coinValText.label = "coin_value";
            coinValText.anchor = 0.5;
            spineSymbol.addSlotObject("multiplier", coinValText);
        }
    }
    if (symbolIndex === GameConstants.SILVER_WILD_SYMOL_ID || symbolIndex === GameConstants.GOLDEN_WILD_SYMOL_ID || symbolIndex > 24) {
        const entry = (symbolIndex > 24 && symbolIndex !== GameConstants.GOLDEN_WILD_SYMOL_ID) ? spineSymbol.state.setAnimation(0, "land", false) : spineSymbol.state.setAnimation(0, "land_1x3_down", false);

        entry.mixDuration = 0;
        entry.trackTime = 0;
        entry.timeScale = 0;
        (spineSymbol as any).lastTime = 0;
        spineSymbol.state.apply(spineSymbol.skeleton);
        spineSymbol.skeleton.updateWorldTransform(Physics.update);
    }


    return spineSymbol;
}






